import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { App } from "./App";
import "./styles.css";
import "./shell/theme-tokens.css";
import "./shell/shell.css";

const container = document.getElementById("root");
if (!container) throw new Error("#root element was not found in index.html");

createRoot(container).render(
	<StrictMode>
		<BrowserRouter>
			<App />
		</BrowserRouter>
	</StrictMode>,
);
